import { SAVEORGSUCCESS, SAVEPARENTSUCCESS, RESETSTOREREGISTER, INVITEPARENT } from "../actions/actionTypes";

// define initial state of auth reducer
const initialState = {
  organization: {},
  parent: {},
  inviteParent: {},
  isOrgRegister: false,
  isParentRegister: false,
};

// update store based on type and payload and return the state
const storeRegister = (state = initialState, action) => {
  switch (action.type) {
    // Update register steps data
    case SAVEORGSUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        organization: { ...data },
        isOrgRegister: true
      };
    }
    case SAVEPARENTSUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        parent: { ...data },
        isParentRegister: true,
      };
    }
    case INVITEPARENT: {
      const { data } = action.payload;
      return {
        ...state,
        inviteParent: { ...data }
      };
    }
    case RESETSTOREREGISTER: {
      return {
        ...state
      };
    }
    default:
      return state;
  }
};

export default storeRegister;